import { Selectable, ShallowDehydrateObject } from 'kysely'
import { UserDevices, Users } from '../db.js'
import { UserSettingsResponse } from './UsersSettings.js'
import { UserTrialPeriod } from './UserTrialPeriod.js'

export type DUserDeviceEntity = Pick<Selectable<UserDevices>, 'deviceId' | 'lastSeen' | 'createdAt' | 'details'>

export type UserDeviceEntity = ShallowDehydrateObject<DUserDeviceEntity>

export type DUserEntity = Omit<Selectable<Users>, 'disabled'> & {
    disabled: boolean
    lastActive: Date | null
    customerName: string | null
    deviceCount: number
}

export type UserEntity = ShallowDehydrateObject<DUserEntity>

export type DUserListItem = Pick<Selectable<Users>, 'id' | 'email' | 'name' | 'userCategory' | 'customerId'> & {
    disabled: boolean
    lastActive: Date | null
    customerName: string | null
    deviceCount: number
}

export type UserListItem = ShallowDehydrateObject<DUserListItem>

export type DUserAdminDetail = DUserEntity & {
    devices: DUserDeviceEntity[]
    /** Present when userCategory is trial and an ongoing period exists (endsAt > now). */
    trialPeriod: Pick<UserTrialPeriod, 'startsAt' | 'endsAt'> | null
}

export type UserAdminDetail = ShallowDehydrateObject<DUserAdminDetail>

export const USER_MULTI_DEVICE_THRESHOLD = 2

export function userHasManyDevices(deviceCount: number): boolean {
    return deviceCount > USER_MULTI_DEVICE_THRESHOLD
}

export type UserMe = Omit<Selectable<Users>, 'settings'> & { settings: UserSettingsResponse }
